import * as React from 'react';
import * as styles from './PeopleFinderCard.css';
import { IAIcon } from '../../icon/Icon';
import { IAPersonaImage } from '../../personaImage/PersonaImage';
import { IPeopleFinderDesign } from '../../../interfaces/IPeopleFinderDesign';

interface IProperties {
  displayName: string;
  email: string;
  mobilePhone: string;
  photo: string;
  jobTitle: string;
  officeLocation: string;
  department: string;
}

export interface IPeopleFinderCardProps {
  onClick?: (index: number) => void;
  properties?: IProperties;
  index?: number;
  design?: IPeopleFinderDesign;
  iconColor?: string;
  isHighlighted?: boolean;
  showSkeleton?: boolean;
}

export class PeopleFinderCard extends React.Component<IPeopleFinderCardProps> {
  private Card = () => (
    <div
      className={styles.IA_peopleFinderCardWrapper}
      style={{
        backgroundColor: this.props.isHighlighted ? '#ffffff' : 'transparent',
        boxShadow: this.props.isHighlighted ? 'rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px' : undefined,
      }}
      onClick={() => this.props.onClick(this.props.index)}
    >
      <div className={styles.IA_peopleFinderCard_profileWrapper}>
        <div
          style={{
            padding: '13px 5px 0px 9px',
          }}
        >
          <IAPersonaImage backgroundColor={this.props.design.colors.iconColor} name={this.props.properties?.displayName} profileImage={this.props.properties?.photo} size={50} fontSize={22} />
        </div>
        <div className={styles.IA_peopleFinderCard_personaPropertyWrapper}>
          <div className={styles.IA_peopleFinderCard_personaProperty} style={{ fontWeight: 400, margin: '10px 0px 2px 0px', color: '#333333', fontSize: '14px' }}>
            {this.props.properties?.displayName}
          </div>
          <div className={styles.IA_peopleFinderCard_personaProperty}>{this.props.properties?.jobTitle}</div>
          <div className={styles.IA_peopleFinderCard_personaProperty}>{this.props.properties?.department}</div>
          <div className={styles.IA_peopleFinderCard_personaProperty}>{this.props.properties?.officeLocation}</div>
        </div>
      </div>
      <div className={styles.IA_peopleFinderCard_feature}>
        {this.props.properties?.email && (
          <div className={styles.IA_peopleFinderCard_feature} style={{ marginLeft: 10 }}>
            <div
              onClick={(e) => {
                e.stopPropagation();
                window.location.href = `mailto:${this.props.properties?.email}`;
              }}
            >
              <IAIcon title="Email" size={16} color={this.props.design.colors.iconColor} />
            </div>
          </div>
        )}
        {this.props.properties.mobilePhone && (
          <a className={styles.IA_peopleFinderCard_feature}>
            <div
              onClick={(e) => {
                e.stopPropagation();
                window.location.href = `tel:${this.props.properties.mobilePhone}`;
              }}
            >
              <IAIcon title="Phone" size={14} color={this.props.design.colors.iconColor} />
            </div>
          </a>
        )}
      </div>
    </div>
  );

  Skeleton = () => (
    <div className={styles.IA_peopleFinderCardWrapperSkeleton} style={{ backgroundColor: '#fff' }}>
      <div className={styles.IA_peopleFinderCard_profileWrapper}>
        <div style={{ padding: '13px 5px 0px 9px' }}>
          <IAPersonaImage showSkeleton name={this.props.properties?.displayName} size={50} />
        </div>
        <div className={styles.IA_peopleFinderCard_personaPropertyWrapper}>
          <div className={styles.IA_peopleFinderCard_PersonaPropertySkeleton} style={{ margin: '10px 0px 2px 0px', color: '#333333', height: 17, width: 100 }} />
          <div className={styles.IA_peopleFinderCard_PersonaPropertySkeleton} />
          <div className={styles.IA_peopleFinderCard_PersonaPropertySkeleton} />
          <div className={styles.IA_peopleFinderCard_PersonaPropertySkeleton} />
        </div>
        <div className={styles.IA_peopleFinderCard_feature} />
      </div>
      <div className={styles.IA_peopleFinderCard_feature} />
    </div>
  );

  public render() {
    return this.props.showSkeleton ? this.Skeleton() : this.Card();
  }
}
